import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import { observer } from "mobx-react"
import { Table } from "semantic-ui-react"
import _ from "lodash"
import ProductRowDefault from "components/Product/ProductRowDefault"
import Responsive from "react-responsive"

@observer
export default class ProductTable extends Component {
  static propTypes = {
    list: PropTypes.object,
    cart: PropTypes.object,
    onChange: PropTypes.func,
    products: PropTypes.array,
  }

  render() {
    let { list, cart, products, onChange } = this.props
    let ProductRow = this.props.row || ProductRowDefault
    let positions = list || products
    if (list) positions = list.products
    let rows = _.map(positions, (product, index) => {
      return (
        <ProductRow key={index} index={index} onChange={onChange} list={list} cart={cart} product={product} />
      )
    })
    return (
      <div>
        <Responsive maxWidth={789}>
          <div className="ba br2 b--black-10">
            <table className="w-100">
              <colgroup>
                <col width="5%" />
                <col width="15%" />
                <col width="50%" />
                <col width="30%" />
              </colgroup>
              <thead>
                <tr className="bb b--black-10 w-100 bg-black-05">
                  <th className="tl pt3 pb3"></th>
                  <th className="tl pt3 pb3"></th>
                  <th className="tl pt3 pb3">{translate("article")}</th>
                  <th className="tl pt3 pb3">{translate("Menge")}</th>
                </tr>
              </thead>
              <tbody>
                {rows}
              </tbody>
            </table>
          </div>
        </Responsive>
        <Responsive minWidth={790}>
          <Table>
            <colgroup>
              <col width="5%" />
              <col width="10%" />
              <col width="25%" />
              <col width="10%" />
              <col width="10%" />
              <col width="15%" />
              <col width="15%" />
            </colgroup>
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
                <th>{translate("article")}</th>
                {/*<th>&nbsp;</th>*/}
                <th>{translate("deliverable")}</th>
                {/*<th>Preis/Stück</th>*/}
                {/*<th>{translate( "deliverable" )}</th>*/}
                {/*<th>{translate("Preis/Stück")}</th>*/}
                <th className="nowrap">{translate("Stückpreis")}</th>
                {/*<th>{translate( "VE" )}</th>*/}
                {/*<th>{translate( "total count" )}</th>*/}
                <th>
                  <div className="tr">
                    {translate("sum")}
                  </div>
                </th>
                {/*<th>{translate( "VE" )}</th>*/}
                {/*<th style={{textAlign: "right"}}>{translate( "amount (VE)" )}</th>*/}
                {list && <th style={{ textAlign: "right" }}>{translate("")}</th>}
                <th>{translate("Menge")}</th>
              </tr>
            </thead>
            <tbody>
              {rows}
            </tbody>
          </Table>
        </Responsive>
      </div>
    )
  }
}







// WEBPACK FOOTER //
// ./src/theme/mags/components/Product/ProductTable.js